
export const TOGGLE_BASKET = 'basket.toggle';
export const TOGGLE_LIVESTREAM = 'livestream.toggle';

export const BASKET_INCREASED = 'basket.countIncreased';

export const BASKET_DECREASED = 'basket.countDecreased';
